import { createContext, useState } from "react";
import PropTypes from "prop-types";

export const RoleFormContext = createContext();
const RoleContext = ({ children }) => {
  const [editData, setEditData] = useState([]);

  return (
    <RoleFormContext.Provider
      value={{
        editData,
        setEditData,
      }}
    >
      {children}
    </RoleFormContext.Provider>
  );
};
RoleContext.propTypes = {
  children: PropTypes.node.isRequired,
};

export default RoleContext;
